import React, { memo, useCallback } from 'react'
import { useEffect } from 'react';
import toast from 'react-hot-toast';
import { useDispatch, useSelector } from 'react-redux';
import { Fade } from 'react-reveal'
import { selectorQuiz, updateQuiz } from '../../../features/quiz/quizSlice';
import questionnaire from '../../../questionnaire'
import { checkElement, getConformSelector } from '../../../utils';
import { FormCard } from '../../FormCard';
import ToastAction from '../../ToastAction';
import Checkbox from '../Checkbox';
import Footer from '../Footer';
import Input from '../Input';
import YesOrNo from '../YesOrNo';

const questionNumbers = ['question2', 'question3']
const { section2 } = questionnaire

const { question2, question3, question4, question5, question6 } = section2.questions

const mapQuestionsIds = {}
question4.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})
question6.answers.forEach(ans => {
  mapQuestionsIds[ans] = getConformSelector(ans)
})

function Step1(props) {
  const dispatch = useDispatch()
  const quiz = useSelector(selectorQuiz)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)

  useEffect(() => {
    questionNumbers.forEach(question => {
      checkElement(`#${question}-${quiz[question]}`)
    })
    checkElement(`#${mapQuestionsIds[quiz.question4]}-choice_question4`)
    checkElement(`#${mapQuestionsIds[quiz.question6]}-choice_question6`)
  }, [])

  useEffect(() => {
    props.firstStep()
  }, [activeWebsite])


  const onSubmit = useCallback((e) => {
    e.preventDefault()

    if (!quiz.question2) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Question2 requise !" description="Veuillez repondre à la question2. (Oui ou Non)" />)

    if (!quiz.question3) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Question3 requise !" description="Veuillez repondre à la question3. (Oui ou Non)" />)

    if (!quiz.question4) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Question4 requise !" description="Veuillez selectionner au moins un choix pour la question 4." />)

    if (quiz.question4 !== question4.answers.at(-1)) {
      const postalCode = e.target[7].value?.trim()
      if (!postalCode) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Question5 requise !" description="Veuillez repondre à la question5." />)
      if (quiz.question5 !== postalCode) dispatch(updateQuiz({ question5: postalCode }))
    } else {
      dispatch(updateQuiz({ question5: null }))
    }

    if (!quiz.question6) return toast.custom((t) => <ToastAction saraExpression="thinking" toastRef={t} label="Question6 requise !" description="Veuillez selectionner au moins un choix pour la question6." />)

    window.scrollTo(0, 0)
    props.nextStep()
  }, [props, question4.answers, quiz.question2, quiz.question3, quiz.question4, quiz.question5, quiz.question6])


  return (
    <form onSubmit={onSubmit}>
      <section className={`section-questions ${quiz.question2 !== 'Oui' ? 'h-full' : ''}`}>
        <FormCard title='PROFIL ENTREPRISE'>
          <h4 className='question'>{question2.label}</h4>
          <YesOrNo padding='p-5' questionNumber={questionNumbers[0]} />
          <h4 className='question'>{question3.label}</h4>
          <YesOrNo padding='p-5' questionNumber={questionNumbers[1]} />
          <div className='mb-10'>
            <h4 className='question'>{question4.label}</h4>
            {question4.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} idEl={mapQuestionsIds[answer]} name='choice_question4' />)}
          </div>
          {quiz.question4 && quiz.question4 !== question4.answers.at(-1) && <Fade>
            <>
              <h4 className='question'>{question5.label}</h4>
              <Input required type='number' name='postalcode' defaultValue={quiz.question5} placeholder='Ex: 95230' invalidMessage='Veuillez renseigner cette question.' />
            </>
          </Fade>}
          <div className='mb-10'>
            <h4 className='question'>{question6.label}</h4>
            {question6.answers.map((answer, key) => <Checkbox key={key} type='radio' option={answer} idEl={mapQuestionsIds[answer]} name='choice_question6' />)}
          </div>
        </FormCard>
      </section>
      <Footer {...props} />
    </form>
  )
}

export default memo(Step1)